export default __webpack_public_path__ + "static/media/profile-bg.e8045ab6.jpeg";